export var defaultVegaTooltipOptions = {
    offsetX: 10,
    offsetY: 10,
    maxDepth: 2
};
